import {useEffect, useState} from "react";
import {searchCampaigns} from "@/api/CampaignApi.ts";
import Campaign from "@/campaigns/model/Campaign.ts";

export function useCampaigns() {
    const [campaigns, setCampaigns] = useState<Campaign[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            setLoading(true);
            setError(false);
            try {
                const results: Campaign[] = [];
                let page = 0;
                let totalPages = 1;
                while (page < totalPages) {
                    const response = await searchCampaigns({page, size: 100, sort: "title"});
                    if (cancelled) return;
                    results.push(...response.content);
                    totalPages = response.page.totalPages;
                    page++;
                }
                setCampaigns(results);
            } catch {
                if (!cancelled) setError(true);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        void load();
        return () => { cancelled = true; };
    }, [attempt]);

    return {campaigns, loading, error, retry: () => setAttempt(value => value + 1)};
}
